import { render, staticRenderFns } from "./BuildTeam.vue?vue&type=template&id=21d9b7ad&scoped=true&"
import script from "./BuildTeam.vue?vue&type=script&lang=js&"
export * from "./BuildTeam.vue?vue&type=script&lang=js&"
import style0 from "./BuildTeam.vue?vue&type=style&index=0&id=21d9b7ad&lang=scss&scoped=true&"
import style1 from "./BuildTeam.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9b7ad",
  null
  
)

export default component.exports